const UsersConstants = {
  RESET: 'USER_RESET',
  GET_SUCCESS: 'USER_GET_SUCCESS',
  GET_FAIL: 'USER_GET_FAIL',
  GET_FOR_OPEN: 'USER_GET_FOR_OPEN',
  GET_FOR_OPEN_SUCCESS: 'USER_GET_FOR_OPEN_SUCCESS',
  GET_FOR_OPEN_FAIL: 'USER_GET_FOR_OPEN_FAIL',
  GET_BY_ID_SUCCESS: 'USER_GET_BY_ID_SUCCESS',
  GET_BY_ID_FAIL: 'USER_GET_BY_ID_FAIL',
  SAVE: 'USER_SAVE',
  SAVE_SUCCESS: 'USER_SAVE_SUCCESS',
  SAVE_FAIL: 'USER_SAVE_FAIL',
  RELOAD: 'USER_RELOAD',
  REFRESH: 'USER_REFRESH',
  SET_FILTER: 'USER_SET_FILTER',
  ACTIVATE_FILTER: 'USER_ACTIVATE_FILTER',
  SET_SORTORDER: 'USER_SET_SORTORDER',
  SET_SELECTION: 'USER_SET_SELECTION',
  MODIFY_SELECTION: 'USER_MODIFY_SELECTION',
  ALLOW_MULTI_SELECT: 'USER_ALLOW_MULTI_SELECT',
  REMOVE: 'USER_REMOVE',
  REMOVE_SUCCESS: 'USER_REMOVE_SUCCESS',
  REMOVE_FAIL: 'USER_REMOVE_FAIL',
  CREATE: 'USER_CREATE',
  OPEN: 'USER_OPEN',
  SET_VALUE: 'USER_SET_VALUE',
  MODIFY: 'USER_MODIFY',
  ENSURE_SELECTION_IS_VISIBLE: 'USER_ENSURE_SELECTION_IS_VISIBLE',
  SET_VISIBLE_RANGE: 'USER_SET_VISIBLE_RANGE',
  FIND_SUCCESS: 'USER_FIND_SUCCESS',
  FIND_FAIL: 'USER_FIND_FAIL',
  GET_FOR_OPEN_BY_NAME: 'USER_GET_FOR_OPEN_BY_NAME',
  GET_FOR_DUPLICATE: 'USER_GET_FOR_DUPLICATE',
  GET_FOR_DUPLICATE_SUCCESS: 'USER_GET_FOR_DUPLICATE_SUCCESS',
  GET_FOR_DUPLICATE_FAIL: 'USER_GET_FOR_DUPLICATE_FAIL',
  OPEN_READONLY: 'USER_OPEN_READONLY',
  DUPLICATE: 'USER_DUPLICATE',
  SET_RESOURCE_VALUE: 'USER_SET_RESOURCE_VALUE',
  SAVE_DUPLICATE_SUCCESS: 'USER_SAVE_DUPLICATE_SUCCESS',
  SAVE_DUPLICATE_FAILURE: 'USER_SAVE_DUPLICATE_FAILURE',
  LOAD_FROM_FILE: 'USER_LOAD_FROM_FILE',
  LOAD_FROM_FILE_SUCCESS: 'USER_LOAD_FROM_FILE_SUCCESS',
  LOAD_FROM_FILE_FAIL: 'USER_LOAD_FROM_FILE_FAIL',
  SET_MODIFIED: 'USER_SET_MODIFIED',
  UPDATE: 'USER_UPDATE',
  GET: 'USER_GET',
  SET_ADVANCED_FILTER: 'USER_SET_ADVANCED_FILTER',
  CLEAR: 'USER_CLEAR'
};

export default UsersConstants;
